import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import { AttemptNav } from './classroom-attempt.style';
import IconArrowLeft from 'approot/shared/icons/icon-arrow-left';
import { Box } from 'approot/shared/design-system/box/box.style';
import { PStyled } from 'approot/shared/styles/typography.style';

export const ClassroomAttemptCount = ({
  length,
  index,
}: {
  length: number;
  index: number;
}) => (
  <Box $justifyContent="center">
    <PStyled marginBottom={0}>{`Attempt ${
      length - index
    } of ${length}`}</PStyled>
  </Box>
);

export const ClassroomAttemptNav = ({
  index,
  total,
  onNext,
  onPrev,
}: {
  index: number;
  total: number;
  onNext: () => void;
  onPrev: () => void;
}) => (
  <AttemptNav>
    <SecondaryButtonIcon
      type="button"
      $borderRadius={40}
      disabled={index === total - 1}
      style={{
        visibility: index === total - 1 ? 'hidden' : 'visible',
      }}
      aria-label="View next attempt"
      onClick={onNext}
    >
      <IconArrowLeft />
    </SecondaryButtonIcon>
    <ClassroomAttemptCount index={index} length={total} />
    <SecondaryButtonIcon
      type="button"
      $borderRadius={40}
      disabled={index === 0}
      style={{
        visibility: index === 0 ? 'hidden' : 'visible',
      }}
      aria-label="View previous attempt"
      onClick={onPrev}
    >
      <IconArrowLeft rotate={180} />
    </SecondaryButtonIcon>
  </AttemptNav>
);
